'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextInput = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(TextInput, _React$Component);

  function TextInput() {
    (0, _classCallCheck3.default)(this, TextInput);
    return (0, _possibleConstructorReturn3.default)(this, (TextInput.__proto__ || (0, _getPrototypeOf2.default)(TextInput)).call(this));
  }

  (0, _createClass3.default)(TextInput, [{
    key: 'focus',
    value: function focus() {
      this.refs.input.focus();
    }
  }, {
    key: 'onValueChange',
    value: function onValueChange(ev) {
      if (this.props.onChange) {
        this.props.onChange(ev.target.value, { name: this.props.name });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          className = _props.className,
          touched = _props.touched,
          active = _props.active,
          simpleError = _props.simpleError,
          error = _props.error;

      var styles = require('./TextInput.scss');

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'span',
          { className: styles.TextInput },
          title ? _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement(
              'span',
              { className: styles.TextInput__label },
              title
            ),
            this.renderInput()
          ) : this.renderInput()
        ),
        !active && touched && error && !simpleError && _react2.default.createElement(
          'span',
          { className: styles.Error },
          error
        )
      );
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      var _classnames;

      var _props2 = this.props,
          type = _props2.type,
          value = _props2.value,
          autoComplete = _props2.autoComplete,
          name = _props2.name,
          placeholder = _props2.placeholder,
          disabled = _props2.disabled,
          touched = _props2.touched,
          error = _props2.error,
          simpleError = _props2.simpleError,
          validating = _props2.validating,
          active = _props2.active,
          inputProps = _props2.inputProps,
          defaultValue = _props2.defaultValue,
          onBlur = _props2.onBlur,
          onFocus = _props2.onFocus;

      var props = (0, _extends3.default)({}, inputProps, { autoComplete: autoComplete, name: name, value: value, disabled: disabled });
      var styles = require('./TextInput.scss');
      var events = {
        onChange: this.onValueChange.bind(this),
        onBlur: onBlur,
        onFocus: onFocus
      };

      var classes = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.InputContainer, true), (0, _defineProperty3.default)(_classnames, styles['InputContainer--error'], !active && touched && simpleError && error), (0, _defineProperty3.default)(_classnames, styles['InputContainer--focused'], active), (0, _defineProperty3.default)(_classnames, styles['InputContainer--with-loader'], validating), _classnames));

      return _react2.default.createElement(
        'span',
        { className: classes },
        _react2.default.createElement('input', (0, _extends3.default)({}, props, { defaultValue: defaultValue, ref: 'input', disabled: disabled, type: type, value: value, placeholder: placeholder }, events)),
        validating && _react2.default.createElement(_components.LoadingIndicator, { className: styles.ValidatingLoader })
      );
    }
  }]);
  return TextInput;
}(_react2.default.Component), _class.propTypes = {
  name: _react2.default.PropTypes.string,
  title: _react2.default.PropTypes.string,
  autoComplete: _react2.default.PropTypes.string,
  type: _react2.default.PropTypes.string,
  placeholder: _react2.default.PropTypes.string,
  defaultValue: _react2.default.PropTypes.string,
  active: _react2.default.PropTypes.bool,
  touched: _react2.default.PropTypes.bool,
  validating: _react2.default.PropTypes.bool,
  simpleError: _react2.default.PropTypes.bool,
  error: _react2.default.PropTypes.string,
  className: _react2.default.PropTypes.string,
  inputProps: _react2.default.PropTypes.object,
  disabled: _react2.default.PropTypes.bool,
  onBlur: _react2.default.PropTypes.func,
  onChange: _react2.default.PropTypes.func
}, _class.defaultProps = {
  type: "text",
  autoComplete: ""
}, _temp);
exports.default = TextInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TextInput/TextInput.jsx
// module id = 2398
// module chunks = 0